import { render } from "./BrandNavigation.vue?vue&type=template&id=4cbbf10a&scoped=true"
import script from "./BrandNavigation.vue?vue&type=script&lang=js"
export * from "./BrandNavigation.vue?vue&type=script&lang=js"

import "./BrandNavigation.vue?vue&type=style&index=0&id=4cbbf10a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cbbf10a"]])

export default __exports__